export enum InputType {
    //    Label = "LABEL",                // Simple output of text (label)
    Action = "ACTION",              // perform a particular action on click, typically a button or so
    PageForward = "PAGEFORWARD",    // Forwarding to a given page by name (i.e. name of page in Page hashmap), kind of a link
    ValueString = "VALUESTRING",    // input type is single string/text value, typically sth. like an Editbox of type string
    ValueNumber = "VALUENUMBER",    // input type is single merical value, typically sth. like an Editbox of type number
    ValueBoolean = "VALUEBOOL",     // input type is single boolean value (true/false), typically sth. like a Checkbox
    Optional = "OPTIONAL",          // input type is a single value from given options, typically sth. like select, dropdown, combo, list with single selectable
    Multiple = "MULTIPLE",          // input type is a many values from given options, typically sth. like list with multi-select
    
    Table = "TABLE",                // 
    Image = "IMAGE",  
    Label = "LABEL",  
    Pdf = "PDF",  
    Upload = "UPLOAD",              // Upload box to drag-and-drop files to upload. Will be added fo UploadFilesList and can be used e.g. in creating PDF's

    Undefined = "UNDEFINED",
    Any = "ANY"
}


// hint for generic component which UI representation is prefered (e.g. if we have an InputOptional, it could be 
// rendered as select or dropdowen, so this gives a hint what is prefered, e.g. dropdown)
export enum UIElementHint {
    Editbox = "EDITBOX",
    Selectbox = "SELECTBOX",
    SelectCard = "SELECTCARD",
    Combobox = "COMBOBOX",
    Dropdown = "DROPDOWN",
    ListSingleSelect = "LISTSINGLESELECT",
    ListMultipleSelect = "LISTMULTIPLESELECT",
    Button = "BUTTON",
    Card = "CARD",
    Undefined = "UNDEFINED",
    Any = "ANY"
}


// ------------------------------------------------------------
export class InputElement {
    name: string = "";
    label: string = "";
    type: InputType = InputType.Undefined;
    value: string | number | string[] | boolean = "";
    isMandatory: boolean = true;
    uiElementHint: UIElementHint = UIElementHint.Any;

    getValue: () => string | number | string[] | boolean = () => { return this.value };

    isVisible: () => boolean = () => { return true };
    isValid: () => boolean = () => { return true };
    onAction: () => boolean | void = () => { return true };

    // Name of a react.js component: we might pass the element as prop to the component (component will test with instanceOf)
    // and maps according to type (e.g. an element of class "selectbox" must match to a react.js component of "select" style)
    //   OR
    // we pass the values to standard react.js-components, but pass the appropriate values of the element here explicitely !!!
    componentname?: string = "";
    unit?: string = "";

    constructor(obj?: Partial<InputElement>) {
        Object.assign(this, obj);
    }
}


// Element for output of simple text (label)
//export class InputLabel extends InputElement {
//    constructor(name: string, value: string) {
//        super(name, InputType.Label, false, UIElementHint.Any);
//    };
//}


// Element to forward to a known page by it's name in the Page hashmap/dictionary
export class InputPageForward extends InputElement {
    type = InputType.PageForward;

    target: string = "";
    content?: string = "";

    constructor(obj?: Partial<InputPageForward>) {
        super(obj);
        Object.assign(this, obj);
    }


    /*constructor(name: string, value: string, target: string, content?: string) {
        super(name, InputType.PageForward, "unlabelled", false, UIElementHint.Any);
        this.target = target;
        this.content = "" || content;
    };*/
}

// Element to forward to a known page by it's name in the Page hashmap/dictionary
export class InputImage extends InputElement {
    type = InputType.Image;
    target: string = "";
    constructor(obj?: Partial<InputPageForward>) {
        super(obj);
        Object.assign(this, obj);
    }
}


// Element for input of single text value  (Editbox)
export class InputSingleValueString extends InputElement {
    type = InputType.ValueString;

    //unit: string = "";

    /*
    /options?: string[];   // optional options: if filled, we use a searechable combobox, otherwise an editbox
    constructor(name: string, value: string, options?: string[], isMandatory?:boolean) {
        super(name, InputType.ValueString, "unlabelled", isMandatory, UIElementHint.Any);
        this.value = value;
        this.options = [] || options;
    };
    */

    constructor(obj?: Partial<InputSingleValueString>) {
        super(obj);
        Object.assign(this, obj);
    }

}

// Element for input of single number (Editbox)
export class InputSingleValueNumber extends InputElement {
    type = InputType.ValueNumber;

    //unit: string = "";
    minValue?: number = 0;
    maxValue?: number = 9999;
    value = 0;
    isValid = () => {
        let ret: boolean = true;
        if (this.minValue !== undefined)
            if (this.value < this.minValue)
                ret = false;

        if (this.maxValue !== undefined)
            if (this.value > this.maxValue)
                ret = false;

        return ret;
    };
    
    constructor(obj?: Partial<InputSingleValueNumber>) {
        super(obj);
        Object.assign(this,obj);
    }

}

export class InputValueBoolean extends InputElement {
    type = InputType.ValueBoolean;

    constructor(obj?: Partial<InputValueBoolean>) {
        super(obj);
        Object.assign(this,obj);
    }
}

// Element for input of one of several possible values (SelectBox, ComboBox, List with one selectable, ...)
export class InputOptional extends InputElement {
    type = InputType.Optional;

    options: string[] = [];
    text: string = "";
    id: string | number = 0;

    // Name of image/model matching to options entry with same index:
    assets: string[] = [];

    // in an optional the value holds the index of the options array !!!
    getValue = () => { return this.options[ this.value as number ] };

    constructor(obj?: Partial<InputOptional>) {
        super(obj);
        Object.assign(this, obj);

        if(this.assets.length === 0) {    // if asset array is empty, i.e. undefined, we initialize it with the contents of options array
            this.assets = this.options;   // be careful when changing asset: SIDE EFFECTS !!!
        }
    }
}

// Input element for input of mulitiple values from a list of options (e.g. list with multiselect)
export class InputMultiple extends InputElement {
    type = InputType.Multiple;

    value: string[] = [];
    options: string[] = [];

    constructor(obj?: Partial<InputMultiple>) {
        super(obj);
        Object.assign(this,obj);
    }
}

// Element for action  (Button)
export class InputAction extends InputElement {
    type = InputType.Action;

    constructor(obj?: Partial<InputAction>) {
        super(obj);
        Object.assign(this,obj);
    }
}


export class InputLabel extends InputElement {
    type = InputType.Label;

    lwidth: number = 40;   // width of label: default is 50%
    label_postfix: string = "";   // e.g. dimension etc.

    constructor(obj?: Partial<InputLabel>) {
        super(obj);
        Object.assign(this,obj);
    }
}


export class InputTable extends InputElement {
    type = InputType.Table;

    header: string[] = [];     // string array of column header
    rows: Array<Array<string>> = [[]];   // array of array (string): each row has an array of string with an entry for each column

    constructor(obj?: Partial<InputTable>) {
        super(obj);
        Object.assign(this,obj);
    }
}


export class InputPdf extends InputElement {
    type = InputType.Pdf;

    data: Uint8Array = new Uint8Array(1);

    constructor(obj?: Partial<InputPdf>) {
        super(obj);
        Object.assign(this,obj);
    }
}


export class InputUpload extends InputElement {
    type = InputType.Upload;

    constructor(obj?: Partial<InputUpload>) {
        super(obj);
        Object.assign(this,obj);
    }
}

export function printElement(e: InputElement): string {
    let output: string = "  InputElement --> ";
    output += ("\n    Name: " + e.name);
    output += ("\n    Type: " + e.type);
    output += ("\n    Value: " + e.value);
    if (e.type === InputType.Optional || e.type === InputType.Multiple) {
        let optionsString: string = "";
        (e as InputMultiple).options.forEach((v: string) => {
            optionsString += (v + " | ");
        }
        );
        output += ("\n    Options: [ " + optionsString + "]");
    }

    output += ("\n    Mandatory: " + e.isMandatory);
    output += ("\n    UI hint: " + e.uiElementHint);

    return output;
}

